var _style, _defs, _g, _defs2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparkle2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 143.6 121.8",
    style: {
      enableBackground: "new 0 0 143.6 121.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000044135397958213567210000004936591015628881082_);}\n\t.st1{fill:#97CEEA;}\n\t.st2{fill:#7EB1CB;}\n\t.st3{fill:#298FC2;}\n\t.st4{clip-path:url(#SVGID_00000145049499793233890520000002621239082899996340_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    transform: "translate(93.893 99.895)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -86.3,
    y: -39,
    width: 64.2,
    height: 57
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074417257824345667800000010329917628134432920_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000074417257824345667800000010329917628134432920_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    className: "st1",
    d: "M-37.8-13.7c-4.8-0.3-8.8-3.8-12-7.1c-3.3-3.2-5.7-7.2-7-11.6c0,0,0-0.1-0.1-0.1 c-0.1-0.1-0.3-0.1-0.4,0c0,0,0,0,0,0.1c-1.3,4.3-3.9,8.2-7.2,11.2c-1.8,1.6-3.7,3.1-5.8,4.3c-2,1.4-4.1,2.5-6.4,3.4 c-0.5,0.2-0.2,0.9,0.3,0.6c0,0,0.1-0.1,0.1-0.1c3.2,1.3,6.3,3,9.1,5.1c2.8,2.2,5.2,4.9,7.1,8c1,1.8,1.9,3.7,2.6,5.6 c0.2,0.6,1.1,0.3,0.9-0.2c0,0,0-0.1,0-0.1c2.3-8.9,9.8-16.6,18.8-18.5c0,0,0,0,0.1,0C-37.4-13-37.4-13.7-37.8-13.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    className: "st2",
    d: "M-22.2-24.7c-2.3-0.1-4.2-1.8-5.7-3.3c-1.6-1.5-2.7-3.4-3.3-5.5c0,0,0,0,0-0.1 c0,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.6,2.1-1.8,3.9-3.4,5.3c-0.8,0.8-1.8,1.4-2.7,2c-1,0.6-2,1.2-3,1.6c-0.2,0.1-0.1,0.4,0.1,0.3 l0.1,0c1.5,0.6,3,1.4,4.3,2.4c1.3,1.1,2.5,2.3,3.4,3.8c0.5,0.8,0.9,1.7,1.2,2.7c0.1,0.3,0.5,0.2,0.4-0.1c0,0,0,0,0,0 c1.1-4.3,4.6-7.7,8.9-8.8h0C-22.1-24.3-22.1-24.6-22.2-24.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    className: "st3",
    d: "M-69.4-31.9c-1.8-0.1-3.3-1.4-4.5-2.7c-1.2-1.2-2.2-2.7-2.7-4.4c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c-0.5,1.6-1.5,3.1-2.7,4.2c-0.7,0.6-1.4,1.2-2.2,1.6c-0.8,0.5-1.6,0.9-2.4,1.3c-0.2,0.1-0.1,0.3,0.1,0.2 c0,0,0,0,0.1,0c1.2,0.5,2.4,1.1,3.4,1.9c1.1,0.8,2,1.9,2.7,3c0.4,0.7,0.7,1.4,1,2.1c0.1,0.2,0.4,0.1,0.3-0.1v0 c0.9-3.4,3.6-6.1,7.1-7h0C-69.2-31.6-69.2-31.9-69.4-31.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    className: "st3",
    d: "M-33.9,1c-1.2-0.2-2.3-0.9-3.1-1.8c-0.8-0.8-1.5-1.8-1.8-3c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c-0.3,1.1-1,2.1-1.8,2.9c-0.5,0.4-1,0.8-1.5,1.1c-0.5,0.3-1.1,0.6-1.6,0.9c-0.1,0,0,0.2,0.1,0.2l0,0 c0.8,0.3,1.6,0.8,2.3,1.3c0.7,0.6,1.3,1.3,1.8,2.1C-39.3,5-39.1,5.5-39,6c0,0.2,0.3,0.1,0.2-0.1v0c0.6-2.3,2.5-4.2,4.8-4.8h0 C-33.8,1.2-33.8,1-33.9,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    className: "st1",
    d: "M-44,13c-0.6-0.1-1.2-0.4-1.5-0.9c-0.4-0.4-0.7-0.9-0.9-1.5c0,0,0,0,0,0c0,0,0,0,0,0l0,0 c-0.2,0.6-0.5,1.1-0.9,1.4c-0.2,0.2-0.5,0.4-0.7,0.6c-0.3,0.2-0.5,0.3-0.8,0.4c-0.1,0,0,0.1,0,0.1h0c0.4,0.2,0.8,0.4,1.2,0.7 c0.4,0.3,0.7,0.6,0.9,1c0.1,0.2,0.2,0.5,0.3,0.7c0,0.1,0.1,0,0.1,0l0,0c0.3-1.2,1.2-2.1,2.4-2.4l0,0C-43.9,13.1-43.9,13-44,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    className: "st3",
    d: "M-67.8,8.6c-2.3-0.1-4.2-1.8-5.7-3.3c-1.6-1.5-2.7-3.4-3.3-5.5c0,0,0-0.1,0-0.1 c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.6,2.1-1.8,3.9-3.4,5.3c-0.8,0.8-1.8,1.4-2.7,2c-0.9,0.6-2,1.2-3,1.6 c-0.2,0.1-0.1,0.4,0.1,0.3l0.1,0c1.5,0.6,3,1.4,4.3,2.4c1.3,1.1,2.5,2.3,3.4,3.8c0.5,0.8,0.9,1.7,1.2,2.7 c0.1,0.3,0.5,0.2,0.4-0.1c0,0,0,0,0,0c1.1-4.3,4.6-7.7,8.9-8.8h0C-67.6,9-67.6,8.7-67.8,8.6"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    transform: "translate(183.571 52.133)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000103955409143994523710000014656341828070141868_",
    x: -94.5,
    y: -37.5,
    width: 47.2,
    height: 41.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044142345891749947730000007779571346328801692_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103955409143994523710000014656341828070141868_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044142345891749947730000007779571346328801692_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_23-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    className: "st2",
    d: "M-65.3-20.2c-1.7-0.1-3.1-1.3-4.2-2.5c-1.2-1.1-2-2.5-2.4-4c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c-0.5,1.5-1.3,2.9-2.5,3.9c-0.6,0.6-1.3,1.1-2,1.5c-0.7,0.5-1.4,0.9-2.2,1.2c-0.2,0.1-0.1,0.3,0.1,0.2l0.1,0 c1.1,0.5,2.2,1,3.2,1.8c1,0.8,1.8,1.7,2.5,2.8c0.4,0.6,0.7,1.3,0.9,2c0.1,0.2,0.4,0.1,0.3-0.1c0,0,0,0,0,0 c0.8-3.2,3.3-5.7,6.6-6.5h0C-65.2-20-65.2-20.2-65.3-20.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    className: "st1",
    d: "M-82.1-32.3c-1.3-0.2-2.5-0.9-3.3-2c-0.9-0.9-1.6-2-1.9-3.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c-0.4,1.2-1.1,2.3-2,3.1c-0.5,0.4-1,0.8-1.6,1.2c-0.6,0.4-1.2,0.7-1.8,0.9c-0.1,0.1,0,0.2,0.1,0.2l0,0 c0.9,0.4,1.7,0.8,2.5,1.4c0.8,0.6,1.4,1.4,2,2.2c0.3,0.5,0.5,1,0.7,1.5c0.1,0.1,0.3,0.1,0.2-0.1v0c0.7-2.5,2.7-4.5,5.2-5.1h0 C-82-32.1-82-32.3-82.1-32.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    className: "st1",
    d: "M-56-8.1c-0.9-0.2-1.7-0.6-2.3-1.3c-0.6-0.6-1.1-1.4-1.3-2.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0 l0,0c-0.2,0.8-0.7,1.6-1.4,2.1c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.3-0.8,0.5-1.2,0.6c-0.1,0,0,0.2,0.1,0.1h0 c0.6,0.2,1.2,0.5,1.7,1c0.5,0.4,1,0.9,1.3,1.5c0.2,0.3,0.4,0.7,0.5,1.1c0,0.1,0.2,0.1,0.2,0l0,0c0.4-1.8,1.8-3.1,3.6-3.5h0 C-55.9-8-55.9-8.1-56-8.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    className: "st3",
    d: "M-63.4,0.8c-0.4-0.1-0.8-0.3-1.1-0.7c-0.3-0.3-0.5-0.7-0.7-1.1c0,0,0,0,0,0c0,0,0,0,0,0 l0,0c-0.1,0.4-0.4,0.8-0.7,1.1c-0.2,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0.2-0.6,0.3c0,0,0,0.1,0,0.1h0c0.3,0.1,0.6,0.3,0.8,0.5 c0.3,0.2,0.5,0.5,0.7,0.8c0.1,0.2,0.2,0.3,0.2,0.5c0,0,0.1,0,0.1,0l0,0C-65,1.7-64.3,1.1-63.4,0.8L-63.4,0.8 C-63.4,0.8-63.4,0.8-63.4,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    className: "st3",
    d: "M-80.9-2.4c-1.7-0.1-3.1-1.3-4.2-2.5c-1.2-1.1-2-2.5-2.4-4c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c0,0,0,0,0,0C-88.1-7.4-89-6.1-90.2-5c-0.6,0.6-1.3,1.1-2,1.5c-0.7,0.5-1.4,0.9-2.2,1.2c-0.2,0.1-0.1,0.3,0.1,0.2l0.1,0 c1.1,0.5,2.2,1,3.2,1.8c1,0.8,1.8,1.7,2.5,2.8c0.4,0.6,0.7,1.3,0.9,2c0.1,0.2,0.4,0.1,0.3-0.1c0,0,0,0,0,0 c0.8-3.2,3.3-5.7,6.6-6.5h0C-80.7-2.2-80.7-2.4-80.9-2.4"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle2);
export default __webpack_public_path__ + "static/media/sparkle_2.5bf2b797977d300b660851bbfb6b8a69.svg";
export { ForwardRef as ReactComponent };